// ProfilePage.jsx
import React, { useState, useEffect } from 'react';
import './ProfilePage.css';
import { FaBuilding, FaEdit, FaEnvelope, FaPhone } from 'react-icons/fa';
import { Link, useParams } from 'react-router-dom';
import { Base_Url } from '../config';
import axios from 'axios';
import dummy from "../Assests/dummy.jpg";

const ProfilePage = () => {
    const [facultyData, setFacultyData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const { id: facultyId } = useParams();

    useEffect(() => {
        const fetchFacultyData = async () => {
            try {
                setIsLoading(true);
                const response = await axios.get(`${Base_Url}/profile/${facultyId}`);
                if (response.data) {
                    setFacultyData(response.data);
                } else {
                    setError("No faculty data found");
                }
            } catch (err) {
                console.error("Error fetching faculty data:", err);
                setError("Failed to fetch faculty data");
            } finally {
                setIsLoading(false);
            }
        };

        fetchFacultyData();
    }, [facultyId]);

    const InfoSection = ({ title, content }) => {
        if (!content) return null;
        
        return (
            <div className="info-section">
                <h4 className="section-title">{title}</h4>
                <div 
                    className="section-content"
                    dangerouslySetInnerHTML={{ 
                        __html: content?.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '') || ''
                    }}
                />
            </div>
        );
    };

    if (isLoading) {
        return <div className="loading">Loading...</div>;
    }

    if (error) {
        return <div className="error">Error: {error}</div>;
    }

    return (
        <div className="profile-container">
            {/* Profile Card Section */}
            <div className="profile-card">
                {facultyData && (
                    <>
                        <img
                            src={facultyData?.image_path != null && facultyData?.image_path !== "" 
                                ? `${Base_Url}/${facultyData.image_path}` 
                                : dummy}
                            alt={facultyData.name}
                            className="profile-image"
                        />
                        <h2 className="profile-name text-white">{facultyData.name}</h2>
                        <p className="profile-title">{facultyData.designation}</p>
                        <div className="profile-contact">
                            <div className="contact-item">
                                <div className="contact-icon">
                                    <FaEnvelope />
                                </div>
                                <p>
                                    <strong className="text-white">Email: </strong>
                                    <span className="text-white">{facultyData.email}</span>
                                </p>
                            </div>
                            <div className="contact-item">
                                <div className="contact-icon">
                                    <FaPhone />
                                </div>
                                <p>
                                    <strong className="text-white">Phone: </strong>
                                    <span className="text-white">
                                        {facultyData.phone ? facultyData.phone : 'N/A'}
                                    </span>
                                </p>
                            </div>
                            <div className="contact-item">
                                <div className="contact-icon">
                                    <FaBuilding />
                                </div>
                                <p>
                                    <strong className="text-white">Web: </strong>
                                    <span className="text-white">{facultyData.weblink}</span>
                                </p>
                            </div>
                        </div>
                    </>
                )}
            </div>

            {/* Profile Details Section */}
            <div className="profile-details pt-3">
                <div className="bio-section">
                    <h3 className='d-flex justify-content-end'>
                        {/* <span className="biotext ps-4 pe-4 ms-2 mt-4">Information</span> */}
                        <Link to={`/editinfo/${facultyData.id}`}>
                        <FaEdit  className='text-primary'/>
                        </Link>
                    </h3>
                    {facultyData && (
                        <div className="info-sections">
                            <InfoSection title="Bio" content={facultyData.bio} />
                            <InfoSection title="CV and Specialization" content={facultyData.cv_and_specialization} />
                            <InfoSection title="Teaching and Research" content={facultyData.teaching_and_research} />
                            <InfoSection title="Academics" content={facultyData.academics} />
                            <InfoSection title="Others" content={facultyData.others} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProfilePage;